import { useState, useEffect,useMemo } from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import { DataGridPro, gridRowIdsSelector, useGridApiRef } from "@mui/x-data-grid-pro";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Breadcrumbs from "./BreadCrumbs";
import { CmpDatePickerField001V1 } from "../../Component/Common/ToolBox/ToolBoxV1";
import GCAutocompleteCheckboxFixSizeUid from "./GCAutocompleteCheckboxFixSizeUid";
import {
  fcheck_null_undefine_replace_empty,
  getStatusStyleV1,
  getUniqueValues,
} from "../../Utility/Utilitys";
import { VNDRDISA_Summary } from "../../Server/ApiV2";
import { Head_Set } from "./SliceVendorDiscontinueChangeRequest";
import { vRdxUserInfo } from "../../Redux/roStore";
import { createMultiSelectOperator } from "../../Component/Common/ReuseableComponent/DatagridFilterColumnComp";

export default function VendorDiscontinueChangeRequest() {
  const isMobile = useMediaQuery("(max-width:600px)");
  const navigate = useNavigate();
  const apiRef = useGridApiRef();

  const dispatch = useDispatch();
  const statusOptions = ["All", "Enter", "Post"];

   const vRdxUserInfoObj = vRdxUserInfo();

  const vRdxHead = useSelector(
    (state) => state.SliceVendorDiscontinueChangeRequest.value.Head
  );
  const vRdxuserLoc = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );

  // const [Location, setLocation] = useState([]);
  const [rows, setRows] = useState([]);
   const [filterObj, setFilterObj] = useState({
    dateFrom: moment().startOf("month").toDate(),
    dateTo: moment().toDate(),
    location: vRdxuserLoc?.map((item) => item.Uid),
    status: "All", // keep label consistent with your Select options
  });
  // const multiSelectMUIlocation = getUniqueValues(rows, "Loc_Name");
  const handleRowClick = (params) => {
    dispatch(
      Head_Set({
        ...vRdxHead,
        A_Transid: params.row?.A_Transid,
        A_Date: params.row?.A_Date,
        A_Location: params.row?.A_Location,
        Loc_Name: params.row?.Loc_Name,
        A_Narration: params.row?.A_Narration,
        A_Status: params.row?.A_Status,
        CreatedBy: params.row?.CreatedBy,
        CreatedDate: params.row?.CreatedDt,
        VendorName: params.row?.VendorName,
        VendorCd: params.row?.A_Vendor,
        A_Locationcsv: params.row?.A_Locationcsv,
        A_Confirm_Status: params.row?.A_Confirm_Status,
        LPOGruppen: params.row?.LPOGruppen,
        LPOGruppenName: params.row?.LPOGruppenName,
        A_Status_CM: params.row?.A_Status_CM,
        A_Status_PM: params.row?.A_Status_PM,
      })
    );
    navigate("/VendorDiscontinueChangeRequestDetail");
  };

  const handleNew = () => {
    dispatch(
      Head_Set({
        A_Transid: 0,
        A_Date: new Date(),
        A_Location:   vRdxuserLoc?.length > 0 ? vRdxuserLoc[0]?.Uid : "",
        Loc_Name: "",
        A_Narration: "",
        A_Status: "ENTER",
        A_Confirm_Status: "ENTER",
        CreatedBy: "",
        CreatedDate: "",
        VendorName: "",
        VendorCd: "",
        A_Locationcsv: "",
        LPOGruppen: "",
        LPOGruppenName: "",
        A_Status_CM: "",
        A_Status_PM: "",
      })
    );
    navigate("/VendorDiscontinueChangeRequestDetail");
  };


   const handleExport = () => {
      apiRef.current.exportDataAsCsv({
      getRowsToExport: ({ apiRef }) => gridRowIdsSelector(apiRef),
      includeHeaders: true,
      utf8WithBom: true,
    });
  };

  const handlePrint = () => {
    apiRef.current.exportDataAsPrint();
  };

  const multiSelectMUIlocation = getUniqueValues(rows,"Loc_Name")

   const loadSummary = async () => {
    const locationStr = Array.isArray(filterObj?.location)
      ? filterObj.location.join(",")
      : filterObj?.location || "";
    const response = await VNDRDISA_Summary(
      fcheck_null_undefine_replace_empty({
        FromDate: filterObj?.dateFrom
          ? moment(filterObj.dateFrom).format("MM/DD/YYYY")
          : "",
        ToDate: filterObj?.dateTo
          ? moment(filterObj.dateTo).format("MM/DD/YYYY")
          : "",
        Location: locationStr,
        Status: filterObj?.status || "",
        UserCd: vRdxUserInfoObj?.UserID || "",
      })
    );

    if (response?.status === 200) {
      setRows(response?.data?.recordset || []);
    } 
  };

  return (
    <div className="div-container">
    <Box className="container-fluid p-2">
      <Breadcrumbs />
      <Grid
        container
        spacing={{ xs: 1, sm: 1.5 }}
        alignItems="end"
        sx={{ marginTop: "8px !important" }}
      >
        <Grid item xs={6} sm={3} md={2.5} lg={1.5}>
          <CmpDatePickerField001V1
            xLabelText="From Date"
            xName="dateFrom"
            xValue={filterObj?.dateFrom}
            xOnChange={(val) =>
               setFilterObj((p) => ({ ...p, dateFrom: val?.$d ?? val }))
            }
          />
        </Grid>
        <Grid item xs={6} sm={3} md={2.5} lg={1.5}>
          <CmpDatePickerField001V1
            xLabelText="To Date"
            xName="dateTo"
            xValue={filterObj?.dateTo}
            xOnChange={(val) =>
            setFilterObj((p) => ({ ...p, dateTo: val?.$d ?? val }))
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4.5} lg={4}>
            <Typography>Location</Typography>
          <GCAutocompleteCheckboxFixSizeUid
            xLabelText="Location"
            options={vRdxuserLoc ?? []} 
            xValue={filterObj.location}
            setValue={(updated) =>
             setFilterObj((p) => ({ ...p, location: updated }))
            }
            objName="location"
            placeholder="Search Location"
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2.5} lg={1.5}>
           <Typography>Status</Typography>
          <FormControl fullWidth>
            {/* <InputLabel id="demo-simple-select-label">Status</InputLabel> */}
            <Select
              size="small"
              value={filterObj?.status || ""}
              onChange={(e) =>
                setFilterObj((p) => ({ ...p, status: e?.target?.value }))
              }
            >
              {statusOptions.map((status) => (
                <MenuItem key={status} value={status}>
                  {status}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={9} md={12} lg={3.5}>
          <Stack
            direction={"row"}
            spacing={1.5}
            sx={{ justifyContent: { sm: "flex-end" } }}
          >
            <Button variant="contained" size="small" onClick={loadSummary}>
              Load
            </Button>
            <Button variant="contained" size="small" onClick={handleNew}>
              New
            </Button>
            <Tooltip title="Export CSV">
              <IconButton color="primary" onClick={handleExport} size="small">
                <DownloadOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Print">
              <IconButton color="primary" onClick={handlePrint} size="small">
                <PrintOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Stack>
        </Grid>
      </Grid>
      <Box
        mt={1}
        sx={{
          height: {
            xs: "57vh", sm: "68vh", md: "71vh", lg: "76vh"
          },
        }}
      >
        <DataGridPro
          apiRef={apiRef}
          rowHeight={30}
          headerHeight={40}
          rows={rows}
          getRowId={(row) => row.A_Transid}
         onRowDoubleClick={(params) => handleRowClick(params)}
          columns={[
            {
              field: "A_Transid",
              headerName: "Trans ID",
              width: 70,
              align: "center",
            },
            {
              field: "A_Date",
              headerName: "Date",
              width: 95,
              align: "center",
              headerAlign: "center",
              valueFormatter: ({ value }) =>
                moment(value).isValid()
                  ? moment(value).format("DD/MM/YYYY")
                  : "",
            },
            {
              field: "A_Location",
              headerName: "Location ID",
              width: 150,
              hide: true,
            },

            {
              field: "Loc_Name",
              headerName: "Location",
              width: 150,
              filterOperators: [
                createMultiSelectOperator(multiSelectMUIlocation),
              ],
            },
            {
              field: "LPOGruppenName",
              headerName: "LPO Group",
              width: 100,
            },
            {
              field: "VendorName",
              headerName: "Vendor",
              width: 220,
            },
            {
              field: "A_Narration",
              headerName: "Narration",
              minWidth: 150,
            },
            {
              field: "A_Status",
              headerName: "Status",
              width: 75,
              renderCell: (params) => {
                const style = getStatusStyleV1(params.value);
                return (
                  <div
                    style={{
                      ...style,
                      padding: "2px 8px",
                      borderRadius: "4px",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </div>
                );
              },
            },
            {
              field: "A_Status_CM",
              headerName: "CM Status",
              width: 80,
              renderCell: (params) => {
                const style = getStatusStyleV1(params.value);
                return (
                  <div
                    style={{
                      ...style,
                      padding: "2px 8px",
                      borderRadius: "4px",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </div>
                );
              },
            },
            {
              field: "A_Status_PM",
              headerName: "PM Status",
              width: 80,
              renderCell: (params) => {
                const style = getStatusStyleV1(params.value);
                return (
                  <div
                    style={{
                      ...style,
                      padding: "2px 8px",
                      borderRadius: "4px",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </div>
                );
              },
            },
            {
              field: "ApproveStatus",
              headerName: "Appr Status",
              width: 90,
              renderCell: (params) => {
                const style = getStatusStyleV1(params.value);
                return (
                  <div
                    style={{
                      ...style,
                      padding: "2px 8px",
                      borderRadius: "4px",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </div>
                );
              },
            },
            {
              field: "CreatedBy",
              headerName: "Created By",
              width: 100,
            },
            {
              field: "CreatedDt",
              width: 100,
              align: "center",
              headerAlign: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
            {
              field: "A_CM_By",
              headerName: "Appr By CM",
              width: 95,
            },
            {
              field: "A_CM_Dt",
              headerName: "CM Appr Date",
              width: 110,
              align: "center",
              headerAlign: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
            {
              field: "A_PM_By",
              headerName: "Appr By PM",
              width: 95,
            },
            {
              field: "A_PM_Dt",
              headerName: "PM Appr Date",
              width: 110,
              align: "center",
                       headerAlign: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
            {
              field: "ApprovedBy",
              headerName: "Confirm By",
              width: 100,
            },
            {
              field: "ApproveDt",
              headerName: "Confirm Date",
              width: 110,
              align: "center",
              headerAlign: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
          ]}
          hideFooter
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? "mui-even-row"
              : "mui-odd-row"
          }
          sx={{
            border: 1,
            borderColor: "primary.light",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#0d73bb",
              color: "white",
            },
          }}
        />
      </Box>
    </Box>
    </div>
  );
}
